import React from 'react';

const ProgressBar = ({ current, total, score }) => {
  const percentage = (current / total) * 100;

  return (
    <div className="progress-container">
      <div className="progress-info">
        <span className="progress-text">
          Progress: {current}/{total}
        </span>
        <span className="score-text">
          Score: {score}/{current}
        </span>
      </div>
      <div className="progress-bar">
        <div 
          className="progress-fill progress-bar-animated"
          style={{ width: `${percentage}%` }}
        >
          <span className="progress-percentage">{Math.round(percentage)}%</span>
        </div>
      </div>
    </div>
  );
};

export default ProgressBar;
